import type { GuestUser, User } from '@creditornot/wolt-auth';

import { jwtDecode } from 'jwt-decode';

import { useAuthState as rawUseAuthState } from '@creditornot/wolt-auth/react';

import { WoltUserId } from 'common/api/api-types';
import { isRunningInPartnerApp } from 'common/utils/webviewUtils';

// Copied from https://github.com/creditornot/wolt.com/blob/b4e89982d60f5f8eb8aac273e2cfa2b4e39f24b8/src/client/js/common-v2/utils/User.ts#L3
export const isWoltUser = (user: GuestUser | User | undefined): user is User => {
  return (user as User)?.roles !== undefined;
};

type JwtPayload = {
  user?: User;
};

const getUserFromJwt = (): User | undefined => {
  try {
    const token = window.woltPartnerAuth?.accessToken;

    if (!token) return undefined;

    return jwtDecode<JwtPayload>(token).user;
  } catch {
    return undefined;
  }
};

export const useAuthState = () => {
  const authState = rawUseAuthState();
  const user = authState.user;

  if (user) {
    return {
      ...authState,
      user: {
        ...user,
        id: WoltUserId.parse(user.id),
      },
    };
  }

  // For WebView: extract user from JWT if wolt-auth doesn't provide it
  if (isRunningInPartnerApp()) {
    const jwtUser = getUserFromJwt();
    if (jwtUser) {
      return {
        ...authState,
        user: {
          ...jwtUser,
          id: WoltUserId.parse(jwtUser.id),
        },
      };
    }
  }

  return authState;
};
